<h2 class="mat-h2">KAM board for Treatment used</h2>

<mat-paginator *ngIf="dataSource.data.length > 0"
  [pageSizeOptions]="getPageSizeOptions(dataSource.data.length)"
  showFirstLastButtons
  aria-label="Select page">
</mat-paginator>

<!-- <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="firstCol20"> -->
<table mat-table [dataSource]="dataSource" matSort class="firstCol20">

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element"> {{ element.name }}</td>
  </ng-container>

  <!-- Total Therapies Used Column -->
  <ng-container matColumnDef="totalTherapiesUsed">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Total # therapies used </th>
    <td mat-cell *matCellDef="let element"> {{ element.totalTherapiesUsed }} </td>
  </ng-container>

  <!-- Therapy Type Columns -->
  <ng-container *ngFor="let therapy of therapyTypes; let i = index" [matColumnDef]="createKey(therapy)">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ therapy }} </th>
    <td mat-cell *matCellDef="let element"> {{ element[createKey(therapy)] }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class]="{ highlight: row.name === 'National average'}"></tr>
</table>
